module.exports = __webpack_public_path__ + "static/media/share-icon-open.16447930.svg";